import { useI18n } from 'next-localization';
import FundDetailsTabRow from 'components/Pages/FundsCenter/FundDetails/FundDetailsTabRow';
import FundDetailsSecondLevelTabGroup from 'components/Pages/FundsCenter/FundDetails/FundDetailsSecondLevelTabGroup';
import { useSelector } from 'react-redux';
import { getAvailableTabs } from '@/store/fundDetails';
import FundDetailsCumulativeTab from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsCumulativeTab';
import FundDetailsAnnualizedTab from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsAnnualizedTab';
import FundDetailsDiscreteTab from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsDiscreteTab';
import FundDetailsCalendarTab from 'components/Pages/FundsCenter/FundDetails/SecondLevelTabs/PerformanceTabs/FundDetailsCalendarTab';
import FundDetailsPerformanceTabCumulativeSection from 'components/Pages/FundsCenter/FundDetails/FundDetailsPerformanceTabCumulativeSection/FundDetailsPerformanceTabCumulativeSection';
import FundDetailsPerformanceDisclaimer from 'components/Pages/FundsCenter/FundDetails/FirstLevelTabs/FundDetailsPerformanceDisclaimer';
import { PerformanceTab } from 'model/FundDetails';

const FundDetailsPerformanceTab = ({ title }: string) => {
  const { t } = useI18n();
  const availablePerformanceTabs: PerformanceTab = useSelector(getAvailableTabs)?.performanceTab;
  const tabComponentsByTabKeys = {
    cumulativeTab: FundDetailsCumulativeTab,
    annualizedTab: FundDetailsAnnualizedTab,
    discreteTab: FundDetailsDiscreteTab,
    calendarTab: FundDetailsCalendarTab,
  };
  const tabTitlesByTabKeys = {
    cumulativeTab: t('fundDetailsTabsPerformanceCumulative'),
    annualizedTab: t('fundDetailsTabsPerformanceAnnualized'),
    discreteTab: t('fundDetailsTabsPerformanceDiscrete'),
    calendarTab: t('fundDetailsTabsPerformanceCalendar'),
  };

  return (
    <section className="default-section-padding background-white">
      <FundDetailsTabRow>
        <h2>{title}</h2>
      </FundDetailsTabRow>

      <FundDetailsTabRow fullWidth className="mt-4">
        {availablePerformanceTabs?.graphSection && <FundDetailsPerformanceTabCumulativeSection />}
      </FundDetailsTabRow>

      <FundDetailsSecondLevelTabGroup
        className="mt-8"
        availableTabs={availablePerformanceTabs}
        tabComponentsByTabKeys={tabComponentsByTabKeys}
        tabTitlesByTabKeys={tabTitlesByTabKeys}
      />

      <FundDetailsPerformanceDisclaimer className="mt-8" />
    </section>
  );
};

export default FundDetailsPerformanceTab;
